//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["list"],
  methods: {
    onClickItem (item,index) {
      if (item.link) {
        if (item.link.indexOf('http') == -1) {
          this.$router.push(item.link)
        } else {
          window.location = item.link
          this.$msg.loading()
        }
      }
      if (item.action) this.$emit(item.action, index)
    },
    go_tixian(item){
      this.$emit("go_page_money",item.OpenId);
    },
  }
};
